import { preload } from "../include/module";
import { showContents } from "../include/module";
import { anchorLink } from "../include/module";
import { toggleHeader } from "../include/module";
import { pageTop } from "../include/module";
import { navCurrent } from "../include/module";





(() => {

  preload();
  showContents();
  anchorLink();
  toggleHeader();
  pageTop();
  navCurrent();

})();



// WEBPACK FOOTER //
// ./src/assets/js/system/script.js